import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, resolveLocale } from "./locale";

import ptBR from "./locales/pt-BR.json";
import ptPT from "./locales/pt-PT.json";
import esES from "./locales/es-ES.json";
import enUS from "./locales/en-US.json";

const resources = {
    "pt-BR": {
        translation: ptBR,
    },
    "pt-PT": {
        translation: ptPT,
    },
    "es-ES": {
        translation: esES,
    },
    "en-US": {
        translation: enUS,
    },
};

/*
 * `fallbackLng` is an OBJECT, not the bare "pt-BR" it used to be, and the
 * pt-PT entry is the reason.
 *
 * A key missing from the European bundle should be read in Brazilian
 * Portuguese — still Portuguese, still understandable — rather than in the
 * default. With the string form every locale fell back to pt-BR anyway, which
 * happened to be right for pt-PT and wrong in principle; spelling the chain out
 * makes the intent explicit and survives the default changing.
 *
 * The `default` key is mandatory in the object form: without it i18next treats
 * a locale with no entry as having NO fallback and leaks the raw key.
 */
const fallbackLng = {
    "pt-PT": ["pt-BR", DEFAULT_LOCALE],
    default: [DEFAULT_LOCALE],
};

i18n.use(initReactI18next).init({
    resources,
    // Normalized, not the raw cookie. The platform emits `pt_PT` and hosts pass
    // a bare `pt`; handing either straight to i18next finds no resource and
    // renders the fallback, which for a European visitor is silently Brazilian.
    lng: resolveLocale(),
    fallbackLng,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
